import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "typeSelect",
    "messageFields",
    "inquiryFields",
    "cartAddFields",
    "cartComboAddFields",
    "cartModifyFields",
    "cartRemoveFields",
    "cartClearFields",
    "maxTurnsField",
    // Legacy targets for backward compatibility
    "cartFields",
    "textFields"
  ]

  connect() {
    if (this.hasTypeSelectTarget) {
      this.toggleFields()
    }
  }

  toggleFields() {
    if (!this.hasTypeSelectTarget) return
    
    const selectedType = this.typeSelectTarget.value
    
    // Hide all type-specific fields and disable required fields
    const fieldTargets = [
      'messageFields',
      'inquiryFields',
      'cartAddFields',
      'cartComboAddFields',
      'cartModifyFields',
      'cartRemoveFields',
      'cartClearFields',
      'cartFields',
      'textFields'
    ]
    
    fieldTargets.forEach(targetName => {
      const hasTarget = this[`has${targetName.charAt(0).toUpperCase() + targetName.slice(1)}Target`]
      if (hasTarget) {
        const target = this[`${targetName}Target`]
        target.classList.add('hidden')
        // Disable required fields in hidden sections
        target.querySelectorAll('[required]').forEach(field => {
          field.removeAttribute('required')
          field.dataset.wasRequired = 'true'
        })
      }
    })
    
    // Map intent types to their field targets
    const typeToFieldMap = {
      'message': 'messageFields',
      'inquiry': 'inquiryFields',
      'cart_add': 'cartAddFields',
      'cart_combo_add': 'cartComboAddFields',
      'cart_modify': 'cartModifyFields',
      'cart_remove': 'cartRemoveFields',
      'cart_clear': 'cartClearFields',
      // Legacy support
      'cart': 'cartFields',
      'text': 'textFields'
    }
    
    // Show the appropriate fields
    const targetFieldName = typeToFieldMap[selectedType]
    if (targetFieldName) {
      this.showFieldsTarget(targetFieldName)
    }
    
    // Toggle max turns visibility - hide only for message type
    if (this.hasMaxTurnsFieldTarget) {
      this.maxTurnsFieldTarget.classList.toggle('hidden', selectedType === 'message')
    }
  }
  
  showFieldsTarget(targetName) {
    const hasTarget = this[`has${targetName.charAt(0).toUpperCase() + targetName.slice(1)}Target`]
    if (hasTarget) {
      const target = this[`${targetName}Target`]
      target.classList.remove('hidden')
      // Re-enable required fields that were previously required
      target.querySelectorAll('[data-was-required="true"]').forEach(field => {
        field.setAttribute('required', '')
        delete field.dataset.wasRequired
      })
    }
  }
}